// extracted by mini-css-extract-plugin
module.exports = {"wrap":"e_n7","pin":"e_o7","tip":"e_p7","wrapOpen":"e_q7"};